import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { theme } from './styles/theme';
import { GlobalStyle } from './styles/global';
import { CartProvider } from './context/CartContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './views/Home';

const cartImport = () => import('./views/Cart');
const Cart = lazy(cartImport);

const App: React.FC = () => {
  React.useEffect(() => {
    if (typeof requestIdleCallback === 'function') {
      const id = requestIdleCallback(() => cartImport());
      return () => cancelIdleCallback(id);
    }
    const timer = setTimeout(() => cartImport(), 2000);
    return () => clearTimeout(timer);
  }, []);
  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CartProvider>
          <GlobalStyle />
          <Header />
          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/carrinho" element={<Cart />} />
            </Routes>
          </Suspense>
          <Footer />
        </CartProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
};

export default App;

